export default __webpack_public_path__ + "static/production-7ad06ea6399ec1c1bc8c5de0b2b31a9e.png";